import React, { FC } from "react";
import { Button, Modal } from "react-bootstrap";
import SearchType from "Vendor/Components/Form/Type/SearchType";
import { useTranslation } from "react-i18next";
import { classUtils as c } from "Vendor/Utils/ClassUtils";

export type HeaderProps = {
    title?: string,
    add?: () => void
    search?: string
    setSearch?: (value: string) => void
    prev?: () => void
    setting?: () => void
    showSetting?: boolean
    prevRotate?: boolean
    disabled?: boolean
    onLoad?: boolean
    importer?: () => void
    showImport?: boolean
    prevDisabled?: boolean
    externalUrl?: string
    modalTitle?: string;
    modalButton?: { icon?: string; onClick?: () => void }
    showModal?: boolean
    closeModal?: () => void
    renderModalContent?: () => React.ReactNode
    renderModalFooter?: () => React.ReactNode
    exportModalTitle?: string;
    exportModalButton?: { icon?: string; onClick?: () => void }
    showExportModal?: boolean
    closeExportModal?: () => void
    renderExportModalContent?: () => React.ReactNode
    renderExportModalFooter?: () => React.ReactNode
}

const Header: FC<HeaderProps> = ({
    title,
    add,
    search = undefined,
    setSearch = undefined,
    prev = undefined,
    setting = undefined,
    showSetting = undefined,
    prevRotate = false,
    prevDisabled = false,
    disabled = false,
    onLoad = false,
    importer,
    showImport = undefined,
    externalUrl = undefined,
    modalTitle,
    modalButton,
    showModal = false,
    closeModal,
    renderModalContent,
    renderModalFooter,
    exportModalTitle,
    exportModalButton,
    showExportModal = false,
    closeExportModal,
    renderExportModalContent,
    renderExportModalFooter,
}) => {
    const { t } = useTranslation()

    return (
        <>
            <header className="container-fluid">
                   <div className="row gy-2 flex-column flex-md-row align-items-start align-items-md-center">
                    <div className={(typeof search !== 'string' || !setSearch) && !add ? 'col' : 'col-12 col-md-3'}>
                        <div className="row justify-content-start align-items-center">
                            {prev && (
                                <div className="col-auto">
                                    <Button onClick={prev} disabled={prevDisabled} variant="secondary"
                                        className={c('btn-icon btn-icon-only', prevRotate && 'btn-icon-rotate-hover')}>
                                        <i className="fa-solid fa-angle-left"></i>
                                    </Button>
                                </div>
                            )}
                            <div className="col w-100">
                                <h1>{title}</h1>
                            </div>
                        </div>
                    </div>
                    {(typeof search === 'string' && setSearch) &&
                        <div className="col position-relative">
                            <SearchType i18nLabel="app.searching" className="form-control-lg-white" name="search" fullName="search" id="search" value={search} setValue={setSearch} floating={false} />
                            {!search && <i className="fa-solid fa-magnifying-glass fa-xl" onClick={() => {
                                document.getElementById('search')?.focus()
                            }}></i>}
                        </div>
                    }
                    <div className="col-3">
                        <div className="row justify-content-start justify-content-md-end align-items-center">
                            <div className="col-auto header-right">
                                {exportModalButton && (
                                    <Button variant="primary" className="btn-icon btn-icon-only" onClick={exportModalButton.onClick}>
                                        <i className={exportModalButton.icon || "fa-solid fa-info-circle"}></i>
                                    </Button>
                                )}
                                {modalButton && (
                                    <Button variant="primary" className="btn-icon btn-icon-only" onClick={modalButton.onClick}>
                                        <i className={modalButton.icon || "fa-solid fa-info-circle"}></i>
                                    </Button>
                                )}
                                {add && <Button variant="primary" className="btn-icon btn-icon-only" onClick={add}
                                    disabled={disabled}>
                                    {(onLoad && disabled)
                                        ? <i className="fa-solid fa-circle-notch fa-spin"></i>
                                        : <i className="fa-solid fa-plus"></i>
                                    }
                                </Button>}
                                {importer && showImport !== false &&
                                    <Button variant="primary"
                                        className={c('btn-icon btn-import', disabled && 'btn-disabled')}
                                        onClick={importer}
                                    >
                                        {(onLoad && disabled)
                                            ? <i className="fa-solid fa-circle-notch fa-spin"></i>
                                            : <i className="fa-solid fa-plus"></i>
                                        }
                                        {t('app.import')}
                                    </Button>}
                                {setting && <Button variant="primary" size="lg" className="btn-icon btn-icon-only" onClick={setting}><i className="fa-solid fa-cog"></i></Button>}
                                {externalUrl && <Button variant="primary" size="lg" className="btn-icon btn-icon-only" href={externalUrl} target="_blank"><i className="fa-solid fa-arrow-up-right-from-square"></i></Button>}
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            {showModal && (
                <Modal show={showModal} onHide={closeModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>{modalTitle}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{renderModalContent?.()}</Modal.Body>
                    <Modal.Footer>
                        {renderModalFooter?.()}
                    </Modal.Footer>
                </Modal>
            )}
            {showExportModal && (
                <Modal show={showExportModal} onHide={closeExportModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>{exportModalTitle}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{renderExportModalContent?.()}</Modal.Body>
                    <Modal.Footer>
                        {renderExportModalFooter?.()}
                    </Modal.Footer>
                </Modal>
            )}
        </>
    )
}

export default Header
